import React, { useEffect, useState } from "react";
import "../css/AuditLogs.css";

const PAGE_LABELS = {
  home: "Home Page",
  about: "About Page"
};

const formatFieldPath = (path) => {
  if (!path) return "—";
  return path.split(".").map((seg,i) => {
    if (!isNaN(Number(seg))) return null;
    const nextSeg = path.split(".")[i+1];
    const isParentOfIndex = nextSeg !== undefined && !isNaN(Number(nextSeg));
    return isParentOfIndex ? `${seg} [${Number(nextSeg) + 1}]`: seg;
  }).filter(Boolean).join(" , ");
};

const ACTION_COLORS = {
  update: "badge-update",
  create: "badge-create",
  delete: "badge-delete"
};

const truncate = (str,n=60) => str && str.length > n ? str.slice(0,n) + "..." : str || "-";



function AuditLogs() {

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterPage, setFilterPage] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
    // const res = await fetch("http://localhost:5000/api/audit-logs");

    const res = await fetch("/api/audit-logs");
    const data = await res.json();
    console.log("audit log", data);

    setLogs(data.data || []);
    } catch(err) {
      console.error("Failed to fetch logs:", err);
    } finally {
      setLoading(false);
    }

  };

  const filtered = logs.filter(log => {
    if (filterPage && log.pageId !== filterPage) return false;
    if (filterAction && log.action !== filterAction) return false;
    if (search) {
      const q = search.toLowerCase();
      if (
        !log.field?.toLowerCase().includes(q) &&
        !log.newValue?.toLowerCase().includes(q) &&
        !log.oldValue?.toLowerCase().includes(q)
      ) return false;
    }
  return true;
  });

  return (

    <div className="auditContainer">

<div className="auditHeader">
      <h2>Audit Logs</h2>
       <button className="refreshBtn" onClick={fetchLogs}>↻ Refresh</button>
   </div>

   <div className="auditFilters">
    <input
    className="auditSearch"
    placeholder="Search field or value..."
    value={search}
    onChange={e => setSearch(e.target.value)}
    />

    <select
    className="auditSelect"
    value={filterPage}
    onChange={e => setFilterPage(e.target.value)}
     >
          <option value="home">Home Page</option>
          <option value="nfirst">N-First Page</option>
          <option value="diplos">Diplos Page</option>
          <option value="dealer">Become a Dealers Page</option>
          <option value="locateDealer">Locate a Dealer Page</option>
          <option value="privacyPolicy">Privacy Policy</option>
          <option value="refundPolicy">Refund Policy</option>
          <option value="termsConditions">Terms & Conditions</option>
          <option value="contactUs">Contact Us Page</option>
          <option value="careers">Careers Page</option>
          <option value="testRide">Book a Test Ride</option>
          <option value="bookNow">Book Now</option>
          <option value="emi">EMI Calculator Page</option>
          <option value="savings">Savings Calculator Page</option>
          <option value="login">Login/OTP/Order Page</option>
          <option value="blogs">Blogs Page</option>
          <option value="commonTestRide">Common Test Ride Page</option>
          <option value="commonBookNow">Common Book Now Page</option>
     </select>

     <select
      className="auditSelect"
      value={filterAction}
      onChange={e => setFilterAction(e.target.value)}
      >
        <option value =""> All Actions</option>
        <option value="create">Create</option>
        <option value="update">Update</option>
        <option value="delete">Delete</option>
      </select>
   </div>
   {loading && <p className="auditloading">Loading logs...</p>}

   {!loading && filtered.length === 0 && (
    <p className="auditEmpty">No logs found.</p>
   )}

   {!loading && filtered.length > 0 && (
      <div className="auditTableWrapper">
      <table className="auditTable">

        <thead>
          <tr>
            <th>Time</th>
              <th>Page</th>
              <th>Section</th>
              <th>Field</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Action</th>
              <th>User</th>
          </tr>
        </thead>

        <tbody>

          {filtered.map((log) => (

            <tr key={log.id} className={`auditRow action-${log.action}`}>
              
              <td className="auditTime">
                {new Date(log.createdAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  hour: "2-digit",
                  minute: "2-digit"
                })}
              </td>

              <td className="auditPage">
                {PAGE_LABELS[log.pageId] || log.pageId}
              </td>

              <td className="auditSection">
                  {log.sectionLabel || log.sectionId}
                </td>   

                <td className="auditField" title={log.field}>
                  {formatFieldPath(log.field)}
                  </td>    

                  <td className={`auditOld ${log.action === "update" ? "strikethrough" : ""}`}>
                    <span title={log.oldValue}>
                      {truncate(log.oldValue)}
                    </span>
                  </td>

                  <td className="auditNew">
                    <span title={log.newValue}>
                      {truncate(log.newValue)}
                    </span>
                  </td>

                  <td>
                    <span className={`actionBadge ${ACTION_COLORS[log.action] || ""}`}>
                      {log.action}
                    </span>
                  </td>

                  <td className="auditUser">
                    {/* #{log.userId} */}
                    {log.AdminUser?.name || `#${log.userId}`}
                  </td>

                  </tr>
          ))}
      

        </tbody>

      </table>
      </div>
   )}
    </div>

  );
}

export default AuditLogs;